import { render, staticRenderFns } from "./orgcampusteacherlist.vue?vue&type=template&id=42fca961"
import script from "./orgcampusteacherlist.vue?vue&type=script&lang=js"
export * from "./orgcampusteacherlist.vue?vue&type=script&lang=js"
import style0 from "./orgcampusteacherlist.vue?vue&type=style&index=0&id=42fca961&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports